import React from 'react';
import { number } from 'prop-types';

export default function ResultCount({ count }) {
    const message = `item ${count > 1 ? 's' : ''} found`;

    return (
        <div className="result-count">
            <span>{`${count} ${message}`}</span>
        </div>
    );
}

ResultCount.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    count: number.isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/toolbar/result-count/index.jsx